export const getUserBillingsEndpoint = userId => `User/${userId}/Billing`;
export const getUserBillingEndpoint = billingId => `User/Billing/${billingId}`;
export const getUserBillingCreateEndpoint = () => 'User/Billing:create';